module.exports = __webpack_public_path__ + "img/marvin-olmos.jpeg";